// Update store/store.js to include the auth reducer
import { configureStore } from '@reduxjs/toolkit';
import clientReducer from './slices/clientSlice';
import authReducer from './slices/authSlice';

export const store = configureStore({
  reducer: {
    clients: clientReducer,
    auth: authReducer,
    
  },
});